module.exports = __webpack_public_path__ + "img/achievement_34.8427b0fa.png";